import { useEffect } from 'react';

const SCROLL_ANIMATION_SELECTOR = `
  .scroll-fade-up,
  .scroll-fade-left,
  .scroll-fade-right,
  .scroll-scale-in,
  .scroll-slide-up,
  .scroll-image-container,
  .scroll-benefit-item,
  .scroll-cta,
  .scroll-hero
`;

function isElementInView(element) {
  const rect = element.getBoundingClientRect();
  const vh = window.innerHeight || 0;
  // Aligné avec rootMargin: '0px 0px -50px 0px'
  return rect.top < vh - 50 && rect.bottom > 0;
}

/**
 * @param {unknown} layoutKey - changer cette valeur (ex. desktop/mobile) force un rebind
 */
export const useScrollAnimations = (layoutKey = null) => {
  useEffect(() => {
    let observer = null;
    let rafId = null;

    const bind = () => {
      if (observer) {
        observer.disconnect();
      }

      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px',
      });

      document.querySelectorAll(SCROLL_ANIMATION_SELECTOR).forEach((element) => {
        observer.observe(element);
        // Après resize / remount : animer tout de suite ce qui est déjà visible
        if (isElementInView(element)) {
          element.classList.add('animate');
        }
      });
    };

    bind();

    const onResize = () => {
      if (rafId != null) {
        cancelAnimationFrame(rafId);
      }
      // Double rAF : après le commit React (métriques HP) + layout
      rafId = requestAnimationFrame(() => {
        rafId = requestAnimationFrame(() => {
          bind();
          rafId = null;
        });
      });
    };

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
      if (rafId != null) {
        cancelAnimationFrame(rafId);
      }
      if (observer) {
        observer.disconnect();
      }
    };
  }, [layoutKey]);
};
